import(/* webpackMode: "eager" */ "/vercel/path0/src/app/map-drawing/page.tsx");
